<template>
  <div class="arp-feedback has-text-centered">
    <b-icon icon="check-circle" size="is-large" type="is-success" class="arp-feedback__icon" />
    <h3 class="title is-5 mt-3">{{ title }}</h3>
    <p v-if="subtitle" class="has-text-grey">{{ subtitle }}</p>
    <div class="arp-feedback__actions">
      <button
        v-if="showDownload"
        type="button"
        class="button is-primary is-outlined"
        @click="onDownload"
      >
        <b-icon icon="download" />
        <span>Download do documento</span>
      </button>
      <button type="button" class="button is-primary" @click="$emit('fechar')">Fechar</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { fileServer } from '@/utils/functions';
import { obterArquivoPrincipalArp } from '../helpers';

export default {
  name: 'ArpFeedback',
  computed: {
    ...mapGetters({
      journey: 'obterArpJourney',
      draft: 'obterArpDraft',
      atas: 'obterOfertaCompraAtasPrecos',
    }),
    title() {
      if (this.journey.mode === 'edit') {
        if (this.journey.isRascunho === false) {
          return 'ARP retificada com sucesso';
        }
        return 'ARP atualizada com sucesso';
      }
      return this.journey.type === 'propria'
        ? 'ARP Enviada com Sucesso'
        : 'ARP gerada com Sucesso!';
    },
    subtitle() {
      if (this.journey.mode === 'edit' && this.journey.isRascunho === false) {
        return 'A retificação foi enviada para processamento no PNCP.';
      }
      if (this.journey.mode === 'edit') {
        return this.journey.type === 'propria'
          ? null
          : 'Faça download do documento atualizado para assinaturas';
      }
      return this.journey.type === 'propria' ? null : 'Faça download do documento para assinaturas';
    },
    showDownload() {
      if (this.journey.type === 'propria') return false;
      if (this.journey.mode === 'edit' && this.journey.isRascunho === false) return false;
      return true;
    },
    arquivoDownload() {
      if (this.draft?.arquivoGerado) return this.draft.arquivoGerado;
      if (this.draft?.ataId) {
        const ata = (this.atas || []).find(a => a.id === this.draft.ataId);
        return obterArquivoPrincipalArp(ata);
      }
      return null;
    },
  },
  methods: {
    onDownload() {
      const arquivo = this.arquivoDownload;
      if (!arquivo) {
        this.$alerta('Documento ainda não disponível para download.', 'is-warning');
        return;
      }
      window.open(fileServer(arquivo), '_blank');
    },
  },
};
</script>

<style scoped>
.arp-feedback {
  padding: 2rem 1rem;
}

.arp-feedback__icon {
  color: #2ea354 !important;
}

.arp-feedback__icon >>> .icon {
  font-size: 3rem;
  color: #2ea354;
}

.arp-feedback__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
  margin-top: 1.5rem;
}
</style>
